var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{staticClass:"mb-3",attrs:{"title":"Histórico de exames","type":"fieldset"}},[_c('List',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }